import { HTTP } from "./http";

let API_SERVER = "";
if (window.location.href.indexOf("8080") > -1) {
  API_SERVER = "http://www.localhost:8888/back-end-endpoint-gps-links.php";
} else {
  API_SERVER = "/personal-training-BE/back-end-endpoint-gps-links.php";
}

/** One service for both providers — the endpoint resolves which club uses what. */
const GpsLinks = {
  listUnlinked(clubId, includeIgnored = false) {
    return HTTP.post(API_SERVER, { action: "listUnlinked", clubId, includeIgnored });
  },
  link(clubId, key, playerId) {
    return HTTP.post(API_SERVER, { action: "linkAthlete", clubId, key, playerId });
  },
  ignore(clubId, key) {
    return HTTP.post(API_SERVER, { action: "ignoreAthlete", clubId, key });
  },
  restore(clubId, key) {
    return HTTP.post(API_SERVER, { action: "restoreAthlete", clubId, key });
  },
};

export { GpsLinks };
